import { UserOutlined } from "@ant-design/icons";
import { Form, Input } from "antd";

import { AUTH_PLACEHOLDERS } from "@/constants";
import { validateAccountValue } from "@/utils/auth-account";

interface AccountFormItemProps {
  name?: string;
  label?: string;
  autoFocus?: boolean;
}

export const AccountFormItem = ({
  name = "account",
  label = "Tài khoản đăng nhập",
  autoFocus = false,
}: AccountFormItemProps) => (
  <Form.Item
    label={label}
    name={name}
    rules={[
      {
        validator: async (_, value: string | undefined) => {
          const error = validateAccountValue(value ?? "");

          if (error) {
            throw new Error(error);
          }
        },
      },
    ]}
  >
    <Input
      autoComplete="username"
      autoFocus={autoFocus}
      prefix={<UserOutlined />}
      placeholder={AUTH_PLACEHOLDERS.account}
    />
  </Form.Item>
);
